(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteLanguageDetailController', PublicSiteLanguageDetailController);

    PublicSiteLanguageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PublicSiteLanguage'];

    function PublicSiteLanguageDetailController($scope, $rootScope, $stateParams, previousState, entity, PublicSiteLanguage) {
        var vm = this;

        vm.publicSiteLanguage = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('vobeApp:publicSiteLanguageUpdate', function(event, result) {
            vm.publicSiteLanguage = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
